export type PostNotificationDialog = { postId: string; surface: 'intro' | 'settings' };
export type PostNotificationOrigin = PostNotificationDialog & { href: string; index: number };

/** Only local post pages (or the isolated dev preview) can be return destinations. */
export const readPostNotificationOrigin = (state: unknown): PostNotificationOrigin | null => {
  const value = (state as { postNotificationOrigin?: PostNotificationOrigin } | null)
    ?.postNotificationOrigin;
  if (!value || !readPostNotificationDialog({ postNotificationDialog: value })) return null;
  if (!Number.isInteger(value.index) || value.index < 0 || typeof value.href !== 'string')
    return null;
  const path = value.href.split(/[?#]/)[0];
  const postPath = path.replace(/^\/(?:ru|en)\//, '/').replace(/\/$/, '');
  const preview = import.meta.env.DEV && /^\/(?:ru\/|en\/)?preview\/match-alerts$/.test(path);
  return postPath === `/posts/${encodeURIComponent(value.postId)}` || preview ? value : null;
};

export const readPostNotificationDialog = (state: unknown): PostNotificationDialog | null => {
  const value = (state as { postNotificationDialog?: PostNotificationDialog } | null)
    ?.postNotificationDialog;
  return value &&
    typeof value.postId === 'string' &&
    value.postId.length > 0 &&
    (value.surface === 'intro' || value.surface === 'settings')
    ? value
    : null;
};
